import { useEffect, useState } from 'react';
import styled from 'styled-components';
import * as S from 'components/join/Step1';

import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import { Popover } from 'antd';

import { ReactComponent as IconDataLined } from 'asserts/icons/ic_data_lined.svg';
import { ReactComponent as IconSearch } from 'asserts/icons/ic_doc_search_2_lined.svg';
import { ReactComponent as IconUnChecked } from 'asserts/icons/ic_check_box_unsel.svg';
import { ReactComponent as IconChecked } from 'asserts/icons/ic_check_box_sel.svg';
import { ReactComponent as IconInfo } from 'asserts/icons/ic_info_circle_lined_blue.svg';

interface SubscribeCardProps {
  name: string;
  subTitle: string | null;
  basicprice: number;
  screentype: 1 | 2;
  uuid: number;
  editable: boolean;
  cardData: DivisionItem[];
  divisionprice: number;
  ticketIdx: number;
  cart: boolean;
  posturereport: string[];
  romtid: string[];
  paymenttypeidx: 1 | 2 | 3 | 4 | 5 | 6 | 10000 | 10001;
  subscribetype: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  membershipData: MemberShipDataTypes;
  licenseData: boolean;
  cartData: MemberShipDataTypes[];
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleClickPutInCart: (membershipName: number) => void;
  handleClickCheckbox: (newData: DivisionItem[], index: number) => void;
}

const SubscribeCard = ({
  name,
  editable,
  subTitle,
  cardData,
  basicprice,
  divisionprice,
  screentype,
  paymenttypeidx,
  membershipData,
  posturereport,
  romtid,
  uuid,
  subscribetype,
  licenseData,
  cartData,
  ticketIdx,
  handleClickPutInCart,
  handleClickCheckbox
}: SubscribeCardProps) => {
  const [checkedPriceTotal, setCheckedPriceTotal] = useState(0);

  const getIsFreeCheck = (ticketIdx: number, cartData: MemberShipDataTypes[]): boolean => {
    let isFreeCheck = false;

    const foundItem = cartData.find((item) => item.ebticketidx === ticketIdx);

    if (foundItem && foundItem.subscribetype === 5 && foundItem.cart === true) {
      isFreeCheck = true;
    }

    return isFreeCheck;
  };

  const isCheckFree = getIsFreeCheck(ticketIdx, cartData);

  const checkedCount = membershipData
    ? membershipData.divisiondata.filter((item) => item.recommendyn).length
    : 0;

  const handleClickLocalCheckbox = (index: number) => {
    if (editable && cardData) {
      const targetItem = cardData[index];

      if (targetItem.originalRecommendyn) {
        return;
      }

      const newData: DivisionItem[] = cardData.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            recommendyn: !item.recommendyn
          };
        }
        return item;
      });

      handleClickCheckbox(newData, index);
    }
  };

  useEffect(() => {
    if (cardData && editable) {
      const initialTotal = cardData
        .filter((item) => item.recommendyn && item.tidprice !== undefined)
        .reduce((acc, curr) => acc + (curr.tidprice || 0), 0);
      setCheckedPriceTotal(initialTotal);
    } else if (cardData && !editable) {
      setCheckedPriceTotal(divisionprice);
    }
  }, [divisionprice, editable, cardData]);

  return (
    <Wrapper>
      <HeaderWrapper>
        <h2>{name}</h2>
        {<h3>{subTitle}</h3>}
      </HeaderWrapper>
      <ContentsWrapper>
        <Contents>
          <div>
            <IconSearch />
            <InnerWrapper>
              <div>
                <h4>기본이용권</h4>
                <Label>필수</Label>
              </div>
              <p>프로그램 로그인 / 피검자(고객) 데이터 관리 / 검사 데이터 & 리포트 관리</p>
            </InnerWrapper>
          </div>
          <DisCountWrapper>
            <Price>{basicprice.toLocaleString()}원</Price>
          </DisCountWrapper>
        </Contents>
        {cardData?.length !== 0 && (
          <Contents>
            <div>
              <IconDataLined />
              <InnerWrapper>
                <div>
                  <h4>검사이용권</h4>
                  {editable && (
                    <SelectCount>
                      선택 {checkedCount}/{cardData && cardData.length}
                    </SelectCount>
                  )}
                </div>

                <Counted>
                  {paymenttypeidx === 4 ? (
                    <p>이용금액 = 1회 검진 시 충전금액에서 차감되는 비용</p>
                  ) : paymenttypeidx === 2 ? (
                    <p>이용금액 = 고객이 검사 진행 시 결제하는 검사 비용(소비자 결제 비용)</p>
                  ) : editable ? (
                    <p>검사 횟수 월 무제한 이용 / 검사 항목 개별 선택 가능</p>
                  ) : (
                    <p>검사 횟수 월 무제한 이용</p>
                  )}
                </Counted>
              </InnerWrapper>
            </div>
            <DisCountWrapper>
              <Price>{checkedPriceTotal.toLocaleString()}원</Price>
            </DisCountWrapper>
          </Contents>
        )}
      </ContentsWrapper>
      {cardData?.length !== 0 ? (
        <>
          <SelectedBoxWrapper>
            {cardData?.map((item, index) => (
              <SelectBox key={item.division}>
                {editable && !licenseData && (
                  <div onClick={() => handleClickLocalCheckbox(index)}>
                    {item.recommendyn ? <IconChecked /> : <IconUnChecked />}
                  </div>
                )}

                <SelectBoxPrice>
                  <div onClick={() => handleClickLocalCheckbox(index)}>
                    <div>{item.divisionname}</div>
                    {!(subscribetype === 1 && !editable) && (
                      <div className="price">
                        {item?.tidprice && <>{item?.tidprice?.toLocaleString()}원</>}
                      </div>
                    )}
                  </div>
                  {item.division === 1 && (
                    <Popover
                      title={'이용가능 리포트'}
                      content={addTagTextList(posturereport)}
                      trigger="click"
                    >
                      <p>이용가능 리포트</p>
                      <IconInfo />
                    </Popover>
                  )}
                  {item.division === 4 && (
                    <Popover
                      title={'이용가능 검사부위'}
                      content={addTagTextList(romtid)}
                      trigger="click"
                    >
                      <p>이용가능 검사부위</p>
                      <IconInfo />
                    </Popover>
                  )}
                  {item.tidprice === 0 && <span>*무료사용</span>}
                </SelectBoxPrice>
              </SelectBox>
            ))}
          </SelectedBoxWrapper>
          <Line>
            <S.Line />
          </Line>
          <Version>
            <p>화면출력</p>
            {screentype === 1 ? <div>PC/노트북</div> : <div>터치모니터/키오스크</div>}
          </Version>
        </>
      ) : (
        <>
          <Line>
            <S.Line />
          </Line>
          {paymenttypeidx === 1 && (<ViewerInfo>*뷰어멤버십이 적용된 PC에서는 검사 진행이 불가능합니다.</ViewerInfo>)}
        </>
      )}
      <CartWrapper onClick={() => handleClickPutInCart(uuid)} disabled={isCheckFree}>
        <p>장바구니</p>
      </CartWrapper>
    </Wrapper>
  );
};

export default SubscribeCard;

export const addTagTextList = (reports: string[]) => {
  return (
    <ul>
      {reports.map((report, index) => (
        <PopUpList key={index}>
          {report.split(',').map((word, wordIndex) => (
            <span key={wordIndex}>{word}&nbsp;</span>
          ))}
        </PopUpList>
      ))}
    </ul>
  );
};

const Wrapper = styled.div`
  position: relative;
  display: flex;
  padding: 32px;
  flex-direction: column;
  gap: 24px;
  border-radius: 16px;
  background: ${color.white};
  box-shadow: 0px 0px 16px 0px ${color.opacityBlack02};
  color: ${color.black2};

  h2 {
    ${font.h3_medium};
  }

  h3 {
    ${font.h4_medium};
  }

  h4 {
    color: ${color.black2};
    ${font.h4_bold};
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Contents = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > div {
    display: flex;
    align-items: center;
  }

  & svg {
    margin-right: 16px;
  }

  & p {
    color: ${color.gray700};
    ${font.caption1_regular};
  }
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & > div {
    display: flex;
    gap: 12px;
    align-items: center;
  }
`;

const CartWrapper = styled.button`
  display: flex;
  padding: 8px 32px;
  align-items: center;
  justify-content: center;
  gap: 24px;
  color: ${color.opacityBlack08};
  border-radius: 24px;
  background: ${color.gradientType1};
  ${font.body_medium};
  cursor: pointer;

  &:disabled {
    opacity: 0.3;
    cursor: initial;
  }
`;

const DisCountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end !important;
`;

const Price = styled.div`
  color: ${color.black};
  text-align: right;
  font-size: 20px;
  ${font.h3_bold};
`;

const Label = styled.div`
  display: inline;
  padding: 4px 12px;
  align-items: center;
  border-radius: 4px;
  background: ${color.red};
  color: ${color.white2};
  ${font.caption2_medium};
`;

const SelectedBoxWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 1%;
  padding-top: 16px;
  border-top: 1px solid ${color.gray200};
`;

const SelectBox = styled.div`
  display: flex;
  gap: 16px;
  width: 32%;
  cursor: pointer;
`;

const SelectBoxPrice = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;
  color: ${color.black2};
  ${font.body_medium};

  & > div {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  & div.price {
    ${font.caption1_regular};
  }

  & span {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 2px;

    color: ${color.blue};
    text-align: center;
    ${font.caption2_medium};
  }
`;

const Counted = styled.div`
  display: flex;
  gap: 12px;

  p {
    ${font.caption1_regular};
    color: ${color.gray700};
  }
`;

const SelectCount = styled.div`
  color: ${color.blue300};
  ${font.caption1_medium}
`;

const Line = styled.div`
  p {
    margin: 0;
    background-color: ${color.gray200};
  }
`;

const ViewerInfo = styled.p`
  color: ${color.red};
  text-align: center;
  ${font.body_medium};
`;

const PopUpList = styled.li`
  font-size: 13px;
  color: #0c0c0c;

  &::before {
    content: '•';
    margin-inline-end: 1ch;
    color: #0c0c0c;
  }
`;

const Version = styled.div`
  display: flex;
  gap: 24px;
  color: ${color.black2};
  ${font.body_medium};
`;
